// Rubrics library + template schemas for the standalone Case-Taking panel.
export const PHYSICIANS = [
  { key: "dr_tejakumar", label: "Dr. Tejakumar Galla · BHMS · M.A. Astrology" },
  { key: "dr_ahalya",    label: "Dr. JNVP Ahalya · BHMS" },
];

export const TEMPLATES = [
  { key: "homoeopathy",   label: "Homoeopathy (Full Sankaran)" },
  { key: "general",       label: "General OPD (Allopathy)" },
  { key: "dermatology",   label: "Dermatology" },
  { key: "orthopedics",   label: "Orthopedics" },
  { key: "pediatrics",    label: "Pediatrics" },
  { key: "gynecology",    label: "Gynecology" },
  { key: "ent",           label: "ENT" },
  { key: "ophthalmology", label: "Ophthalmology" },
  { key: "psychiatry",    label: "Psychiatry" },
  { key: "physiotherapy", label: "Physiotherapy Assessment" },
];

// Rubric groups for the Homoeopathy tick-selector
export const RUBRIC_GROUPS = {
  "Mind — Emotional": [
    "Anxiety about health", "Anxiety about future", "Anxiety about family", "Fear of death",
    "Fear of dark", "Fear of alone", "Fear of animals", "Fear of thunder", "Fear of robbers",
    "Anger — sudden", "Anger — suppressed", "Anger — violent", "Weeping — easy",
    "Weeping — better in company", "Sadness / grief", "Ailments from grief",
    "Ailments from disappointment", "Ailments from suppressed anger",
    "Confidence — lack of", "Ambition — increased", "Jealousy",
    "Suicidal disposition", "Indifference", "Detachment",
  ],
  "Mind — Intellectual": [
    "Concentration difficult", "Memory weak", "Absent-minded", "Confusion of mind",
    "Slow comprehension", "Restlessness of mind", "Delusions",
  ],
  "Generals — Thermal": [
    "Chilly (worse cold)", "Hot (worse heat)", "Sensitive to draft", "Sensitive to change of weather",
    "Better open air", "Worse open air", "Better warm room", "Worse warm room",
    "Perspiration profuse", "Perspiration on covered parts", "Perspiration on head",
  ],
  "Generals — Cravings & Aversions": [
    "Craves sweets", "Craves salt", "Craves sour", "Craves spicy", "Craves cold drinks",
    "Craves warm drinks", "Craves fatty food", "Craves milk", "Craves eggs",
    "Aversion to milk", "Aversion to meat", "Aversion to sweets", "Aversion to fats",
    "Thirst — increased", "Thirst — diminished", "Thirst for large quantities",
  ],
  "Modalities — General": [
    "Worse morning", "Worse afternoon", "Worse evening", "Worse night", "Worse before midnight",
    "Worse after midnight", "Better rest", "Worse rest", "Better motion", "Worse motion",
    "Better lying down", "Worse lying down", "Better pressure", "Worse pressure",
    "Worse before storm", "Better after eating", "Worse after eating",
  ],
  "Sleep": [
    "Sleep — restless", "Sleep — deep", "Insomnia", "Sleep on back",
    "Sleep on abdomen", "Sleep on side", "Talks in sleep", "Grinds teeth in sleep",
    "Snores", "Walks in sleep", "Dreams of falling", "Dreams of dead people",
    "Dreams of water", "Dreams of animals", "Nightmares",
  ],
  "Sensations": [
    "Burning", "Cutting", "Throbbing", "Pressing", "Stitching", "Tearing",
    "Cramping", "Bruised", "Numbness", "Tingling", "Heaviness", "As if broken",
  ],
};
